/**
 * Legacy routes — migrated from the old monolithic src/App.js.
 *
 * These cover the pages that existed before the route-registry was introduced.
 * They are registered first so future feature routes (TASK-07+) can shadow or
 * extend them.
 *
 * Status: these pages still use the old authInterceptor from
 *   src/services/axios/interceptor.js.  They will be replaced one by one as
 *   each feature task (07, 09, 12, 14, 16, 18) migrates their pages to the
 *   new src/api/client + TanStack Query pattern.
 */
import React from "react";
import { Login } from "../../pages/login";
import { ValidateAccount } from "../../pages/validate_account";
import { Register } from "../../pages/register";
import { Home } from "../../pages/home";
import { Bills } from "../../pages/bills";
import { Profile } from "../../pages/profile";
import { Planning } from "../../pages/planning";
import { Rate } from "../../pages/rate";
import { RequireRole } from "./RequireRole";

const legacyRoutes = [
  // ── Public ──────────────────────────────────────────────────────────────
  { path: "/login",                     element: <Login />,           public: true },
  { path: "/register",                  element: <Register />,        public: true },
  { path: "/activate/:uid/:token",      element: <ValidateAccount />, public: true },

  // ── Protected (any authenticated user) ──────────────────────────────────
  // selfLayout: these legacy pages still render their own <BaseLayout> (old
  // template navbar+sidebar), so AppLayout must NOT wrap them in the new shell
  // or the layout renders twice. Drop the flag as each page migrates to the
  // new shell.
  // "/" ahora es la landing pública (features/landing). El Home legacy vive en
  // /home para no romper el flujo del login legacy (window.location.href).
  {
    path: "/home",
    element: <RequireRole />,
    selfLayout: true,
    children: [{ index: true, element: <Home /> }],
  },
  {
    path: "/bills",
    element: <RequireRole />,
    selfLayout: true,
    children: [{ index: true, element: <Bills /> }],
  },
  {
    path: "/profile",
    element: <RequireRole />,
    selfLayout: true,
    children: [{ index: true, element: <Profile /> }],
  },
  {
    path: "/activity",
    element: <RequireRole />,
    selfLayout: true,
    children: [{ index: true, element: <Planning /> }],
  },
  {
    path: "/rate/:activity",
    element: <RequireRole />,
    selfLayout: true,
    children: [{ index: true, element: <Rate /> }],
  },
];

export { legacyRoutes };
